import type {
  AssignmentKind,
  AssignmentPreview,
  AssignmentResult,
  NewProcess,
} from '@testflow/shared';
import { request } from './api.js';

// TF-006 (#112, A7): die drei Umhäng-Kanten hinter EINEM Endpunktpaar. Der Rumpf ist für alle
// drei identisch — das ist die Voraussetzung dafür, dass auch die Oberfläche mit EINEM
// Bedienmuster auskommt (auswählen → Ziel → Vorschau → ausführen → Ergebnis).
export interface AssignmentMoveBody {
  kind: AssignmentKind;
  ids: string[];
  target_id: string | null;
  /** #153: nur bei kind 'testcases' und target_id null — Prozess in derselben Transaktion anlegen. */
  new_process?: NewProcess;
}

const base = (p: string) => `/v1/projects/${p}/assignment`;

export const assignmentApi = {
  preview: (p: string, body: AssignmentMoveBody) =>
    request<AssignmentPreview>(`${base(p)}/preview`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  apply: (p: string, body: AssignmentMoveBody) =>
    request<AssignmentResult>(`${base(p)}/apply`, { method: 'POST', body: JSON.stringify(body) }),
};
